module.exports = __webpack_public_path__ + "static/media/SDGIcons_4.39901106.png";